import {FC, useState} from 'react';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Box from '@mui/material/Box';

import TableHeadContactPerson from './TableHeadContactPerson/TableHeadContactPerson';
import TableBodyContactPerson from './TableBodyContactPerson/TableBodyContactPerson';
import ContactPersonAddModal from './ContactPersonAddModal/ContactPersonAddModal';

import {IHeadCellContactPerson} from '../../../../../../shared/types/table.types';

const headCells: IHeadCellContactPerson[] = [
  {
    disablePadding: false,
    id: 'fullPersonName',
    label: 'ФИО',
  },
  {
    disablePadding: false,
    id: 'phoneNumber',
    label: 'Номер телефона',
  },
  {
    disablePadding: false,
    id: 'email',
    label: 'Email',
  },
  {
    disablePadding: false,
    id: 'birthDate',
    label: 'Дата рождения',
  },
];

const ContactPersonForm: FC = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  return (
    <Box sx={{width: '100%'}}>
      <TableContainer>
        <Table size="small">
          <TableHeadContactPerson headCells={headCells} collapse actionButtons />
          <TableBodyContactPerson handleOpen={handleOpen} />
        </Table>
      </TableContainer>
      <ContactPersonAddModal open={open} handleClose={handleClose} />
    </Box>
  );
};

export default ContactPersonForm;
